export enum StatToDisplayEnum {
    PER_DATE = 'perDate',
    TOTAL = 'total',
}
